export default "__VITE_ASSET__BhbheUbl__"